import { Model } from '../model';

export class DeliveryNotification extends Model {
  url: string;
  method: string;
}

export class SmsPreferencesSMS extends Model {
  defaultSender?: string;
  defaultMessageTypeId?: string;
  defaultTestNumber?: string;
  deliveryNotification?: DeliveryNotification | null;
  isSenderLock?: boolean;
  isSenderSuperSetted?: boolean;
}

export class SmsPreferencesBusinessHour extends Model {
  hourFrom?: string;
  hourTo?: string;
}

export class SmsPreferences extends Model {
  sms?: SmsPreferencesSMS;
  businessHour?: SmsPreferencesBusinessHour;
}
